import Vue from 'vue';
import App from './App.vue';
import router from './router/index.js';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faExternalLinkAlt, faHandPointUp, faShip, faArrowCircleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faExternalLinkAlt, faHandPointUp, faShip, faArrowCircleRight);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
